/**
 * Polyfills
 *
 * @see https://www.npmjs.com/package/es6-object-assign
 * @see https://www.npmjs.com/package/svgxuse
 *
 * @package Globus
 * @since   1.0.1
 */

import es6promise from 'es6-promise';
import es6objectassign from 'es6-object-assign';
import 'nodelist-foreach-polyfill';
import Stickyfill from 'stickyfilljs';

es6promise.polyfill();
es6objectassign.polyfill();

/**
 * Stickyfill
 *
 * Polyfill for CSS `position: sticky`
 *
 * @see https://github.com/wilddeer/stickyfill
 *
 * @since 1.0.0
 */
function initStickyfill() {
	const stickyEls = document.querySelectorAll('.sticky');
	Stickyfill.add(stickyEls);
}

document.addEventListener('DOMContentLoaded', initStickyfill);

/**
 * Cross-browser requestAnimationFrame function.
 *
 * @since 1.0.1
 */
window.requestAnimationFrame = window.requestAnimationFrame
	|| window.mozRequestAnimationFrame
	|| window.webkitRequestAnimationFrame
	|| window.msRequestAnimationFrame
	|| function (f) { setTimeout(f, 1000 / 60); };
